import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, distinctUntilChanged, distinctUntilKeyChanged, filter, map, switchMap, tap } from 'rxjs/operators';
import * as fromShared from '../../../shared';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { CityService } from '../../city.service';
import * as actions from './city.actions';

@Injectable()
export class CityEffects {
    private last: { state: string; zipCode: string } = {
        state: null,
        zipCode: null
    };
    constructor(
        private actions$: Actions,
        private log: LoggingService,
        private service: CityService
    ) {}

    LoadCities$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.getCitys),
            distinctUntilChanged((p, c) => {
                return p.State === c.State && p.ZipCode === c.ZipCode;
            }),
            // filter(
            //     a =>
            //         !(
            //             this.last.zipCode === a.ZipCode &&
            //             this.last.state === a.State
            //         )
            // ),
            tap(a => this.log.verbose({ type: 'CityEffects:LoadCities$', a })),
            switchMap(a => {
                // this.last.zipCode = a.ZipCode;
                // this.last.state = a.State;
                return this.service.get(a.State, a.ZipCode).pipe(
                    tap(citys =>
                        this.log.verbose({
                            type: 'CityEffects:LoadCities$:response',
                            citys
                        })
                    ),
                    map(citys => actions.loadCitys({ citys })),
                    catchError(fromShared.Errors.handleServiceError)
                );
            })
        );
    });
}
